<div #textElement class="ag-cell-value">
  <span [matTooltip]="getText()" [matTooltipDisabled]="!showTooltip" [matTooltipHideDelay]="tooltipHideDelayMs" [matTooltipShowDelay]="tooltipShowDelayMs">
    {{ getText() }}
  </span>
</div>
